<script>
import Loader from "./components/loaders/Loader.vue";
import '@/assets/tailwind.css';
import { resetAutoLogoutTimer, checkInactiveTimeOut } from "@/plugins/auth";
import { HMIS_USERNAME } from "@/plugins/vars";

export default {
  name: 'app',

  mounted() {
    resetAutoLogoutTimer();
      setInterval(() => {
          if(this.$router.history.current.meta.requiresAuth) {
            checkInactiveTimeOut();
          }
      }, 1000);
    this.fetchRights();
  },

  methods: {
    resetLogoutTimer() {

      resetAutoLogoutTimer();
    },

    fetchRights() {
      if(!window.Cookies.get(HMIS_USERNAME)) return;
      let url = `Admin/GetAllUserRights`;
          url += `?UserName=${window.Cookies.get(HMIS_USERNAME).toLowerCase()}`;
      this.$http.get(url).then(({ data }) => {
          window.localStorage.setItem('P_102', window.JSON.stringify(data));
      }).catch(() => {});
    },
  },

  components: {
    Loader
  }
}
</script>
<template>
  <div id="app" @mousemove="resetLogoutTimer" class="font-sans">
    <router-view></router-view>
      <Loader :loadingMessage="'Processing'"/>
  </div>
</template>
<style>
 .max-w-40 {
   max-width: 10rem;
 }
</style>
